module.exports = __webpack_public_path__ + "static/media/video1-min.0ac1cc49.mov";